export const SET_HIGHLIGHT = "SET_HIGHLIGHT";

export const setHighlight = (highlight) => {
  return {
    type: SET_HIGHLIGHT,
    payload: highlight,
  };
};
